module.exports = __webpack_public_path__ + "img/中国工商银行.b8e18255.png";